// REACT
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
// REDUX
import { connect } from "react-redux";
import { updateItemCategory } from "../../Actions/firebaseActions";
// COMPONENTS
import Header from "../Presentation/Header/Header";
import Paper from "@material-ui/core/Paper";
import Item from "../Presentation/Item/Item";

class ItemScreen extends Component {
  onBackClick = () => {
    this.props.history.push("/MainScreen");
  };

  updateCategory = (ean, category) => {
    this.props.updateItemCategory(this.props.username, ean, category);
  };

  render() {
    return (
      <div className="ItemScreen">
        <Header
          isLoggedIn={false}
          onFeedBackClick={this.onFeedBackClick}
          currentUser={this.props.username}
          language={this.props.language}
          showBackBtn={true}
          onBackClick={this.onBackClick}
        />
        <div className="container-fluid col-lg-8 col-md-11 col-sm-11">
          <Paper
            elevation={6}
            style={{
              marginTop: "85px",
              paddingTop: "15px",
              paddingBottom: "10px",
              borderRadius: "15px",
              paddingLeft: "20px",
              paddingRight: "20px",
            }}
          >
            <Item
              item={this.props.selectedItem}
              language={this.props.language}
              onBackClick={this.onBackClick}
              updateCategory={this.updateCategory}
            />
          </Paper>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  username: state.firebase.username,
  language: state.firebase.language,
  listenerActive: state.firebase.listenerActive,
  selectedItem: state.firebase.selectedItem,
});

const mapDispatchToProps = (dispatch) => {
  return {
    updateItemCategory: (uid, EAN, cat_name) =>
      dispatch(updateItemCategory(uid, EAN, cat_name)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ItemScreen)
);
